import { render, staticRenderFns } from "./AddBalanceFirstStepModal.vue?vue&type=template&id=0da5b854"
import script from "./AddBalanceFirstStepModal.vue?vue&type=script&lang=js"
export * from "./AddBalanceFirstStepModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports